// Single source of truth for cart/navbar price math so they can never drift apart.
import { calculateSalePrice } from './calculateSalePrice';
import { getRegionPrice } from './getRegionPrice';

// Build the object calculateSalePrice/getRegionPrice expect from either a live
// product or a cart-item snapshot (which stores raw_price + sale fields at add time).
const toPricingSource = (source) => ({
  region_prices: source.region_prices,
  regional_sale_prices: source.regional_sale_prices,
  on_sale: source.on_sale,
  sale_type: source.sale_type,
  sale_value: source.sale_value,
  sale_price: source.sale_price,
  sale_start_date: source.sale_start_date,
  sale_end_date: source.sale_end_date,
  price: source.raw_price != null ? source.raw_price : source.price
});

// Per-unit MSRP (no sale), already in the selected currency.
export const getUnitMSRP = (source, currency) => getRegionPrice(toPricingSource(source), currency);

// Per-unit effective price (sale price when applicable), already in the selected currency.
export const getUnitEffective = (source, currency) => {
  const s = calculateSalePrice(toPricingSource(source), currency);
  return s.isOnSale && s.effectivePrice ? s.effectivePrice : getUnitMSRP(source, currency);
};

// Add-ons total for one cart line, recomputed in the selected currency.
export const getAddonsTotal = (item, currency) =>
  (item.selectedAddons || []).reduce((sum, a) => {
    const ap = currency === 'CAD' ? (a.price_cad || a.price) : a.price;
    return sum + (ap * (a.quantity || 1));
  }, 0);

// Effective total for one cart line (unit + add-ons) * quantity.
export const getCartItemTotal = (item, currency) =>
  (getUnitEffective(item, currency) + getAddonsTotal(item, currency)) * (item.quantity || 1);

// Cart grand total (sum of effective line totals).
export const getCartTotal = (items, currency) =>
  (items || []).reduce((sum, i) => sum + getCartItemTotal(i, currency), 0);
